import { describeApiFailure } from './describeApiFailure'

const SAVE_FAILED = 'The form could not be saved'

/** Describes a failed write the API did not name, for the alert above the box. */
export const describeSaveFailure = (error: unknown): string =>
  describeApiFailure(error, SAVE_FAILED)
